export default {
  intro: {
    default: 'Entrez les informations de la personne qui signe le contrat.',
    gbr: "Entrez les informations de l'associé qui signe le contrat.",
    gmbh: 'Entrez les informations du propriétaire ou du gérant qui signe le contrat.',
  },
  sections: {
    home_address: 'Adresse personnelle',
    home_address_help: "Le lieu de résidence de cette personne, pas l'adresse du restaurant.",
  },
  form: {
    owner_first_name: {
      label: 'Prénom',
      placeholder: 'Entrez le prénom',
    },
    owner_last_name: {
      label: 'Nom',
      placeholder: 'Entrez le nom',
    },
    owner_dob: {
      label: 'Date de naissance',
      placeholder: 'Date',
    },
    owner_phone_number: {
      label: 'Téléphone',
    },
    owner_email: {
      label: 'E-mail',
      placeholder: "Entrez l'e-mail",
      help: "Peut être différent de l'e-mail utilisé pour vous connecter.",
    },
    owner_id_number: {
      label: "Numéro d'identification (ex. numéro de sécurité sociale aux États-Unis)",
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Retour',
    next: 'Suivant',
  },
};
